import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Modal as BsModal } from 'react-bootstrap';
export const Footer = ({ actionLabel, closeLabel, onClose, onAction }) => {
    return (_jsxs(BsModal.Footer, { children: [!!onClose && (_jsx(Button, Object.assign({ variant: 'black', onClick: onClose }, { children: !!closeLabel ? closeLabel : 'Cancel' }))), !!onAction && (_jsx(Button, Object.assign({ variant: 'primary', onClick: onAction }, { children: !!actionLabel ? actionLabel : 'Yes' })))] }));
};
